export default adyenV2BillingAddress => ({
  useShippingAddress: false,
  organisationName: null,
  buildingNameNumber: adyenV2BillingAddress.houseNumberOrName || null,
  line1: adyenV2BillingAddress.street || null,
  line2: null,
  line3: adyenV2BillingAddress.city || null,
  line4: adyenV2BillingAddress.stateOrProvince || null,
  postcode: adyenV2BillingAddress.postalCode || null,
  countryCode: adyenV2BillingAddress.country || null,
});
